import React from 'react';

export interface UserProfileContextModel {
	userId: number | undefined;
	userProfileId: number | undefined;
	b2cId: string | undefined;
	token: string | undefined;
}

export const UserProfileContext = React.createContext<UserProfileContextModel>({
	userId: undefined,
	userProfileId: undefined,
	b2cId: undefined,
	token: undefined
});
